export type ConnectedPagesMode = 'tree' | 'graph' | 'org';

export const ConnectedPagesModeSearchPaths = {
  tree: 'mode=tree',
};
